export const courseSignOrderStateEnum = [
    {
        stateId: "UNPAID",
        stateName: "待支付"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    },
    {
        stateId: "CLOSED",
        stateName: "已关闭"
    },
    {
        stateId: "USE_AVAILABLE",
        stateName: "可用"
    },
    {
        stateId: "REFUNDING",
        stateName: "退款中"
    },
    {
        stateId: "REFUNDED",
        stateName: "已退款"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    },
]